import { AutoTextarea, Field, ListEditor } from "./shared";

const COLORS = [
  "border-rose-300 bg-rose-50/60 dark:bg-rose-950/20",
  "border-sky-300 bg-sky-50/60 dark:bg-sky-950/20",
  "border-violet-300 bg-violet-50/60 dark:bg-violet-950/20",
  "border-amber-300 bg-amber-50/60 dark:bg-amber-950/20",
  "border-orange-300 bg-orange-50/60 dark:bg-orange-950/20",
  "border-fuchsia-300 bg-fuchsia-50/60 dark:bg-fuchsia-950/20",
  "border-teal-300 bg-teal-50/60 dark:bg-teal-950/20",
];

const Block = ({ block, value, onChange, color, testId }) => (
  <div className={`rounded-xl border-2 p-3 space-y-2 ${color}`} data-testid={testId}>
    <div>
      <h4 className="text-sm font-semibold">{block.label}</h4>
      <p className="text-[11px] text-muted-foreground">{block.hint}</p>
    </div>
    <AutoTextarea value={value.content} onChange={(v) => onChange({ ...value, content: v })} placeholder="Contenu clinique…" rows={3} testId={`${testId}-content`} />
    <AutoTextarea value={value.explanation} onChange={(v) => onChange({ ...value, explanation: v })} placeholder="Explication (rôle dans la boucle)…" rows={2} className="text-xs italic bg-background/60" testId={`${testId}-explanation`} />
  </div>
);

export const AbcMapForm = ({ analysisKey, data, onChange, specs, config }) => {
  const blocks = specs[config.blocks];
  const setBlock = (k, v) => onChange({ ...data, blocks: { ...data.blocks, [k]: v } });
  const adaptive = analysisKey === "abc_adaptive";
  return (
    <div className="space-y-4" data-testid={`abc-map-${analysisKey}`}>
      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3 items-start">
        {blocks.map((b, i) => (
          <Block key={b.key} block={b} value={data.blocks?.[b.key] || { content: "", explanation: "" }} onChange={(v) => setBlock(b.key, v)} color={COLORS[i % COLORS.length]} testId={`abc-block-${b.key}`} />
        ))}
        <div className="rounded-xl border-2 border-dashed border-primary/40 p-3 space-y-2 sm:col-span-2 xl:col-span-1">
          <h4 className="text-sm font-semibold text-primary">{adaptive ? "Modèle personnel de résilience" : "Hypothèse de fonctionnement"}</h4>
          <AutoTextarea value={data.hypothesis} onChange={(v) => onChange({ ...data, hypothesis: v })} placeholder={adaptive ? "Comment le patient fait face quand ça fonctionne…" : "Comment la boucle s'entretient…"} rows={6} testId="abc-hypothesis" />
        </div>
      </div>
      {adaptive ? (
        <div className="grid md:grid-cols-2 gap-3">
          <Field label="Forces personnelles identifiées" hint="Une par ligne"><ListEditor value={data.strengths} onChange={(v) => onChange({ ...data, strengths: v })} testId="abc-strengths" /></Field>
          <Field label="Transfert vers les situations problèmes"><AutoTextarea value={data.transfer} onChange={(v) => onChange({ ...data, transfer: v })} rows={3} testId="abc-transfer" /></Field>
        </div>
      ) : (
        <Field label="Notes / points à explorer"><AutoTextarea value={data.notes} onChange={(v) => onChange({ ...data, notes: v })} rows={2} testId="abc-notes" /></Field>
      )}
    </div>
  );
};
